import conn from "@/store/utils/connection";
import resulter from "@/store/utils/resulter";
import api from "../apiEndPoint";

export default {
  getDetailOwner: ({ commit }) => {
    conn
      .get(api.getDataDetailOwner)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setDetailOwner", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
  },

  getListJenisTraining: ({ commit }) => {
    let query = {
      sort_by: "harga",
      order_by: "ASC",
      limit: "4",
    };
    conn
      .get(api.getListJenisTraining, query)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setDataJenisTraining", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
  },

  getDetailJenisTraining: ({ commit }, params_idJenis) => {
    let query = {
      idjenis: params_idJenis,
    };
    conn
      .get(api.getDetailJenisTraining, query)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setDetailJenisTraining", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
  },

  postDataTrainingCreate: async ({ commit }, data) => {
    let res = await conn
      .post(api.postTrainingCreate, data)
      .then((response) => {
        if (response.data === undefined) {
          commit("setResponse", resulter.errorResult(response));
        } else {
          if (response.data.code === 200) {
            if (response.data.status) {
              commit("setTrainingCreate", response.data.data);
            } else {
              commit("setResponse", resulter.errorResult(response.data.msg));
            }
          }
        }
        return response;
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
    return res;
  },
  postCekPromo: async ({ commit }, dataInput) => {
    let data = { kode_promo: dataInput };
    let res = await conn
      .post(api.postPromo, data)
      .then((response) => {
        if (response.data === undefined) {
          commit("setResponse", resulter.errorResult(response));
        } else {
          if (response.data.code === 200) {
            if (response.data.status) {
              commit("setPromo", response.data.data);
            } else {
              commit("setResponse", resulter.errorResult(response.data.msg));
            }
          }
        }
        return response;
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
    return res;
  },
  getListJenisExist: ({ commit }, Data) => {
    conn
      .get(
        api.getDataJadwalExist +
          "?idjenis=" +
          Data.idjenis +
          "&date=" +
          Data.date
      )
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setListJenisExist", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
  },
  getRiwayatTraining: ({ commit }, status) => {
    conn
      .get(api.getRiwayatListTraining + "?status=" + status)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setRiwayatTraining", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
  },
  getAkunKeuangan: async ({ commit }) => {
    let res = await conn
      .get(api.getListAkunKeuangan)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setListKeuangan", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
        return response;
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
    return res;
  },
  getDetailBayar: ({ commit }, idTraining) => {
    let query = { idtraining: idTraining };
    conn
      .get(api.getDetailPembayaran, query)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setDetailBayar", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
  },
  getJadwalUnavailable: async ({ commit }, data) => {
    let res = await conn
      .get(api.getUnavailableJadwal, data)
      .then((response) => {
        if (response.data.code == 200) {
          if (response.data.code == 200) {
            commit("setJadwalUnavailable", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.code));
          }
        }
        return response;
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
    return res;
  },
  getDetailTraining: async ({ commit }, idTraining) => {
    let query = {
      idtraining: idTraining,
    };
    let res = await conn
      .get(api.getDataDetailTraining, query)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setDetailTraining", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
        return response;
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
    return res;
  },

  postUlasan: async ({ commit }, data) => {
    let query = {
      idtraining: data.query,
    };

    const res = await conn
      .post(api.postDataUlasan + "?idtraining=" + query.idtraining, data.data)
      .then((response) => {
        if (response.data === undefined) {
          return response;
        } else {
          if (response.data.code === 200) {
            if (response.data.status) {
              commit("setDataUlasan", response.data.data);
            } else {
              commit("setResponse", resulter.errorResult(response.data.msg));
            }
            return response.data;
          }
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });

    return res;
  },

  getDataListTraining: async ({ commit }, data) => {
    let query = {
      offset: data.offset,
      limit: data.limit,
      key: data.paramSearch,
    };

    const res = await conn
      .get(api.getListTraining, query)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setDataListTraining", response.data.data);
            commit("setCountListTraining", response.data.length);
            commit("setNextPagination", response.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
        return response;
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });

    return res;
  },

  getDataTimeExist: ({ commit }, query) => {
    conn
      .get(
        api.getDataJadwalRescedule +
          "?idjenis=" +
          query.idjenis +
          "&date=" +
          query.date
      )
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setDataJadwalExist", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
  },

  postRescedule: async ({ commit }, Data) => {
    let data = {
      id_detail_training: Data.idDetailTraining,
      jadwal_mulai: Data.jadwalMulai,
      jadwal_selesai: Data.jadwalSelesai,
    };
    const res = await conn
      .post(api.postDataRescedule + "?idjenis=" + Data.idJenis, data)
      .then((response) => {
        if (response.code === undefined) {
          commit("setResponse", resulter.errorResult(response));
        } else {
          if (response.data.code === 200) {
            if (response.data.status) {
              commit("setDataRescedule", response.data.data);
            } else {
              commit("setResponse", resulter.errorResult(response.data.msg));
            }
            // alert(response.data);
            // alert(response.data.msg)
          }
        }
        return response;
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
    return res;
  },

  getDataDetailPembayaran: async ({ commit }, idTraining) => {
    let query = {
      idtraining: idTraining,
    };
    const res = await conn
      .get(api.getDetailPembayaran, query)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setDataDetailPembayaran", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
        return response;
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
    return res;
  },

  getDataJadwalDisable: async ({ commit }, data) => {
    const res = await conn
      .get(api.getDataJadwalUnavailable, data)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.code == 200) {
            commit("setDataJadwalUnavailable", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
        return response;
      })
      .catch((error) => {
        commit("setResponse", resulter.errorResult(error));
      });

    return res;
  },

  getTagihan: async ({ commit }, idTraining) => {
    let query = {
      idtraining: idTraining,
    };
    const res = await conn
      .get(api.getInformasiTagihan, query)
      .then((response) => {
        if (response.data.code === 200) {
          if (response.data.status) {
            commit("setInformasiTagihan", response.data.data);
          } else {
            commit("setResponse", resulter.errorResult(response.data.msg));
          }
        }
        return response;
      })
      .catch((e) => {
        commit("setResponse", resulter.errorResult(e));
      });
    return res;
  },
};
